import dayjs, { Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import _ from 'lodash';

dayjs.extend(utc);
dayjs.extend(timezone);

export const parseDateTime = (
  format = 'YYYY-MM-DD HH:mm:ss',
  date: Dayjs | string = dayjs()
) => {
  let businessTimezone = 'Australia/Hobart';
  const isValidActiveRole =
    localStorage.getItem('active_role_key') === 'rBusiness' ||
    localStorage.getItem('active_role_key') === 'rCandidate';

  if (isValidActiveRole) {
    const queTimezone = localStorage.getItem('que_timezone');
    businessTimezone =
      !_.isNull(queTimezone) &&
      !_.isUndefined(queTimezone) &&
      queTimezone !== 'undefined'
        ? queTimezone
        : 'GMT';
  }

  return dayjs
    .utc(date)
    .local()
    .tz(businessTimezone, true)
    .format(format);
};

export default dayjs;
